module.exports = __webpack_public_path__ + "img/emptyData.f48ad907.png";